import { ActionCard } from "./ActionCard.js";
import { ACTION_CARD_COUNTS } from "@/game-rules/constants/actionCardCounts.js";

export class TireurDelite extends ActionCard {
    static typeId = "TIREUR_DELITE";
    static cardName = "Tireur d'Élite";
    static colorHex = "#B432FF";
    static countInDeck = ACTION_CARD_COUNTS.TIREUR_DELITE;
    static description = "Tirez sur n’importe quelle carte de la ligne de tir, qu’elle soit mise en joue ou non";

    isValidOn(slotIndex, gameState) {
        return true;
    }

    resolve(slotIndex, gameState) {
        gameState.resolveKills([slotIndex], this.typeId);
    }
}
